import { render, staticRenderFns } from "./account.vue?vue&type=template&id=30629024&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30629024')) {
      api.createRecord('30629024', component.options)
    } else {
      api.reload('30629024', component.options)
    }
    module.hot.accept("./account.vue?vue&type=template&id=30629024&", function () {
      api.rerender('30629024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personalCenter/components/account.vue"
export default component.exports